// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"8a1659e8","563":"ac3c6289","787":"4274ec21"}[chunkId] + ".chunk.js";
};